<template>
<b-sidebar
  id="languages-form-sidebar"
  :visible="isLanguagesFormSidebarActive"
  bg-variant="white"
  sidebar-class="sidebar-lg"
  shadow
  backdrop
  no-header
  right
  @shown="getData(languagesData)"
  @hidden="resetForm"
  @change="(val) => $emit('update:is-languages-form-sidebar-active', val)"
>
  <template #default="{ hide }">
    <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
      <h5 class="mb-0">
        Group Form
      </h5>
      <feather-icon
        class="ml-1 cursor-pointer"
        icon="XIcon"
        size="16"
        @click="hide"
      />
    </div>
    <validation-observer
      #default="{ handleSubmit }"
      ref="refFormObserver"
    >
      <b-form
        class="p-2"
        @submit.prevent="handleSubmit(onSubmit)"
        @reset.prevent="resetForm"
      >
        <validation-provider
          #default="validationContext"
          name="Name"
          rules="required"
        >
          <b-form-group
            label="Name"
            label-for="Name"
          >
            <b-form-input
              id="name"
              v-model="Data.name"
              autofocus
              :state="getValidationState(validationContext)"
              trim
              placeholder="Name"
            />
            <b-form-invalid-feedback>
              {{ validationContext.errors[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>
        <validation-provider
          #default="validationContext"
          name="Code"
          rules="required"
        >
          <b-form-group
            label="Code"
            label-for="Code"
          >
            <b-form-input
              id="code"
              v-model="Data.code"
              autofocus
              :state="getValidationState(validationContext)"
              trim
              placeholder="Code"
            />
            <b-form-invalid-feedback>
              {{ validationContext.errors[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>
        <div class="border rounded p-2">
          <h4 class="mb-1">Language Image</h4>
          <b-media
            no-body
            vertical-align="center"
            class="flex-column flex-md-row"
          >
            <b-media-aside>
              <b-img
                ref="refPreviewEl"
                :src="Data.url?Data.url:require('@/assets/images/no-image.png')"
                height="75"
                width="75"
                class="rounded mr-2 mb-1 mb-md-0"
              />
            </b-media-aside>
            <b-media-body>
              <small class="text-muted">
                Recommend image resolution 75x75.
              </small>
              <b-card-text class="my-50"> </b-card-text>
              <div class="d-inline-block">
                <b-form-file
                  ref="refInputEl"
                  v-model="Data.iconFile"
                  accept=".jpg, .png, .gif, .webp,"
                  placeholder="Choose file"
                  @input="inputImageRenderer"
                />
              </div>
              <b-card-text class="my-50">
                <b-button
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="outline-primary"
                  v-if="Data.url"
                  @click="revomeImage"
                  >Remove Image</b-button
                >
              </b-card-text>
            </b-media-body>
          </b-media>
        </div>
        <br/>
        <validation-provider
          #default="validationContext"
          name="is_active"
          rules="min:0"
        >
          <b-form-group
            label="Is Active"
            label-for="is_active"
          >
            <b-form-checkbox
              id="is_active"
              checked="true"
              class="custom-control-success"
              v-model="Data.is_active"
              switch
            />
            <b-form-invalid-feedback>
              {{ validationContext.errors[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>
        <div class="d-flex mt-2">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-2"
            type="submit"
          >
            Submit
          </b-button>
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            type="button"
            variant="outline-secondary"
            @click="hide"
          >
            Cancel
          </b-button>
        </div>
      </b-form>
    </validation-observer>
  </template>
</b-sidebar>
</template>
  
<script>
import {
  BSidebar, BForm, BFormGroup, BFormInput, BFormCheckbox, BFormInvalidFeedback, BButton,
  BMedia, BMediaAside, BImg, BMediaBody, BCardText, BFormFile,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { ref } from '@vue/composition-api'
import { required, alphaNum, email } from '@validations'
import formValidation from '@core/comp-functions/forms/form-validation'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import store from '@/store'
import { slugify } from '@/@fake-db/utils'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { useInputImageRenderer } from "@core/comp-functions/forms/form-utils";  

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    vSelect,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    BMedia,
    BMediaAside,
    BImg,
    BMediaBody,
    BCardText,
    BFormFile,
  },

  directives: {
    Ripple,
  },

  model: {
    prop: 'isLanguagesFormSidebarActive',
    event: 'update:is-languages-form-sidebar-active',
  },

  props: {
    isLanguagesFormSidebarActive: {
      type: Boolean,
      required: true,
    },
    
    languagesData: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      required,
      alphaNum,
      email

    }
  },
   
  setup(props, { emit }) {
    const toast = useToast();
    const blankData = {
      name: '',
      cde: '',
      url: '',
      is_active: true,
    }
    const Data = ref(JSON.parse(JSON.stringify(blankData)))
    const refInputEl = ref(null);
    const refPreviewEl = ref(null);

    const { inputImageRenderer } = useInputImageRenderer(
      refInputEl,
      (base64) => {
        refPreviewEl.value.src = base64;
      }
    );

    const resetData = () => {
      Data.value = JSON.parse(JSON.stringify(blankData))
    }

    const getData = (data)=>{
      console.log('data', data);
      if(data){ 
        Data.value  = JSON.parse(JSON.stringify(data))
        Data.value.is_active = Data.value.is_active === 1?true:false;
      }
    }
      
    const onSubmit = () => {
      Data.value.is_active = Data.value.is_active?1:0;
      console.log('test',Data.value)

      const formData = new FormData();
      formData.append('iconFile', refInputEl.value.files[0])
      formData.append('data', JSON.stringify(Data.value))

      if(Data.value.id){
        store.dispatch('app-languages/updateData', {
          id: Data.value.id,
          formData: formData
        })
          .then((response) => {
            if(response.data.success === true){
              toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                title: `Success`,
                icon: 'BellIcon',
                variant: 'success',
                text: `${response.data.message}`,
                },
              });
            }else{
              toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                title: `Error`,
                icon: 'BellIcon',
                variant: 'danger',
                text: `${response.data.message}`,
                },
              });

            }

            emit('refetch-data')
            emit('update:is-languages-form-sidebar-active', false)
          }
        )
      } else {
        store.dispatch('app-languages/addData', formData)
          .then((response) => {
            console.log('response',response);
            if(response.data.success === true){
              toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                title: `Success`,
                icon: 'BellIcon',
                variant: 'success',
                text: `${response.data.message}`,
                },
              });
            } else {
              toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                title: `Error`,
                icon: 'BellIcon',
                variant: 'danger',
                text: `${response.data.message}`,
                },
              });

            }

            emit('refetch-data')
            emit('update:is-languages-form-sidebar-active', false)
          })
      }
    }

    const revomeImage = () => {
      Data.value.url = ''
      // refPreviewEl.value.src = require("@/assets/images/no-image.png");
    };
  
    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(resetData)

    const changeTitle  = () => {
      Data.value.slug =  slugify(Data.value.title )
    }
  
    return {
      Data,
      onSubmit,
      inputImageRenderer,
      refFormObserver,
      getValidationState,
      resetForm,
      getData,
      changeTitle,
      refInputEl,
      refPreviewEl,
      revomeImage,
    }
  },
}
</script>
  
<style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
  
  #languages-form-sidebar {
    .vs__dropdown-menu {
      max-height: 200px !important;
    }
  }
</style>
  